module.exports = __webpack_public_path__ + "static/media/pdf_banner.c496f286.jpg";